import { TypedDocumentNode, gql } from '@apollo/client';

import useQuery from '@sorare/core/src/hooks/graphql/useQuery';

import {
  CardRecommendationHeaderFollowQuery,
  CardRecommendationHeaderFollowQueryVariables,
} from './__generated__/useFollowCardQuery.graphql';

const CARD_RECOMMENDATION_FOLLOW_QUERY = gql`
  query CardRecommendationHeaderFollowQuery($cardSlug: String!) {
    anyCard(slug: $cardSlug) {
      slug
      currentUserSubscription {
        slug
      }
    }
  }
` as TypedDocumentNode<
  CardRecommendationHeaderFollowQuery,
  CardRecommendationHeaderFollowQueryVariables
>;

export const useFollowCardQuery = (cardSlug: string) => {
  const { refetch } = useQuery(CARD_RECOMMENDATION_FOLLOW_QUERY, {
    variables: { cardSlug },
    skip: !cardSlug,
    fetchPolicy: 'cache-only',
    nextFetchPolicy: 'network-only',
  });

  return refetch;
};
